import React, { useEffect, useState } from 'react';

interface CustomButtonProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  title?: string;
  className: string;
  disabled?: boolean;
  type: 'submit' | 'reset' | 'button';
  handleClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => Promise<any>;
}

export default function CustomButton({
  type,
  className,
  children,
  style,
  title,
  disabled = false,
  handleClick,
}: CustomButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!handleClick) return;
    setIsLoading(true);

    handleClick(event)
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className='position-relative d-inline-block'>
      <button
        // eslint-disable-next-line react/button-has-type
        type={type}
        className={className}
        style={style}
        disabled={isLoading || disabled}
        title={title}
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
          onClick(e)
        }
      >
        {isLoading && (
          <div className='position-absolute top-50 start-50 translate-middle'>
            <span
              className='spinner-border spinner-border-sm'
              aria-hidden='true'
            />
          </div>
        )}
        {children}
      </button>
    </div>
  );
}
